const locale = {
  placeholder: 'Hora',
};

export default locale;
